import { getSsoUrl } from '@/pages/token-management/service';
import { getAuthUserId } from '@/utils/auth';
import {
  setTokenPlatformOwner,
  setTokenPlatformToken,
  setTokenPlatformUserId,
} from '@/utils/token-platform-auth';

/**
 * 免密跳转到用户自己的 new-api 平台控制台。
 *
 * 复用 token-management 既有的 SSO 链路（getSsoUrl → POST /bff/gateway/user/token-platform/sso-url，
 * 返回 sso_url + access_token），再以隐藏表单 POST 到 new-api 的 SSO 端点完成免密登录，
 * 等价于原模型广场页右上角「Token平台控制台」按钮的行为。不自造新协议（WIS-369 opt4）。
 *
 * @param redirect new-api 内落地路径，默认 /dashboard
 * @returns `{ ok }` 成功已提交表单新开标签页；`{ ok: false, message }` 失败（调用方可 message.error）
 */
export async function openTokenPlatformConsole(
  redirect = '/dashboard',
): Promise<{ ok: boolean; message?: string }> {
  if (typeof document === 'undefined')
    return { ok: false, message: '仅在浏览器可用' };
  try {
    const res = await getSsoUrl(redirect);
    if (res.success && res.sso_url && res.access_token) {
      const wischoicerUserId = getAuthUserId();
      if (res.new_api_user_id != null && wischoicerUserId) {
        // 三元组完整时才一起落盘，避免部分更新造成跨账号串号。
        setTokenPlatformToken(res.access_token);
        setTokenPlatformUserId(res.new_api_user_id);
        setTokenPlatformOwner(wischoicerUserId);
      }
      const form = document.createElement('form');
      form.method = 'POST';
      form.action = res.sso_url;
      form.target = '_blank';
      const tokenInput = document.createElement('input');
      tokenInput.type = 'hidden';
      tokenInput.name = 'access_token';
      tokenInput.value = res.access_token;
      form.appendChild(tokenInput);
      const redirectInput = document.createElement('input');
      redirectInput.type = 'hidden';
      redirectInput.name = 'redirect';
      redirectInput.value = res.redirect || redirect;
      form.appendChild(redirectInput);
      document.body.appendChild(form);
      form.submit();
      document.body.removeChild(form);
      return { ok: true };
    }
    return { ok: false, message: res.message || '获取控制台链接失败' };
  } catch {
    return { ok: false, message: '获取控制台链接失败，请稍后再重试' };
  }
}
